import type { EmailTemplateEntity } from './entity_types/EmailTemplate';
import { hFetch } from './hFetch';

export const list = async () => {
  return (await hFetch({ url: '/api/email_templates' })) as { records: EmailTemplateEntity[] };
};
